export const PATHS = {
  ROOT: 'wages',
  ME: 'wages/me',
  getByUserId: (userId: number) => `wages/${userId}`,
};
